import React from 'react'
import styled, { keyframes } from 'styled-components';
import logo from '../assets/images/LOGOMASTERBETS365.svg';
import { SECONDARY } from '../const/colors';

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${SECONDARY};
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const animate = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.4;
  }
  80% {
    opacity: 0.8;
    transform: scale(1.05);
  }
  100% {
    opacity: 0;
    transform: scale(1.10);
  }
`;

const ImgContainer = styled.div`
  padding: 1rem;
  width: 270px;
  img {
    animation: ${animate} 3s linear forwards infinite;
  }
`;

const LoaderFull = () => {
  return (
    <Container>
      <ImgContainer>
       <img src={logo} alt='logo' />
      </ImgContainer>
    </Container>
  )
}

export default LoaderFull